module.exports = __webpack_public_path__ + "static/media/bazar-hindu.7bf1e93c.jpg";